import { ActionContext, MutationTree, ActionTree, GetterTree } from 'vuex'
import webApi from '../webApi'
import { Currency } from '../webApi/DataModels'
import { map, filter } from 'lodash'

class CurrencyState {
  public currencies: Currency[] = []
  public currencyOptions: any[] = []
}

const mutations = <MutationTree<CurrencyState>>{
  setCurrencies (state: CurrencyState, currencies: Currency[]) {
    state.currencies = currencies
    state.currencyOptions = currencies.map((currency: Currency) => {
      return {
        value: currency.Currency_ID,
        label: currency.Currency_Code,
        selected: false
      }
    })
    window.sessionStorage.setItem('Currency_List', JSON.stringify(state.currencies))
  },
  reset (state:CurrencyState) {
    state.currencies = []
    state.currencyOptions = []
  }
}

const actions = <ActionTree<CurrencyState, any>>{
  reset (store: ActionContext<CurrencyState, any>):void {
    store.commit('reset')
  },
  loadCurrencies (store: ActionContext<CurrencyState, any>):Promise<any> {
    if (window.sessionStorage.getItem('Currency_List') != null) {
      // the list has already been stored in session
      store.commit('setCurrencies', JSON.parse(window.sessionStorage.getItem('Currency_List')))
      return Promise.resolve('success')
    } else {
      // the list has not been stored in session yet, load from server
      return webApi.currency.get_Currencies().then(
        (response) => {
          // Store the response
          store.commit('setCurrencies', response.data)
          return Promise.resolve('success')
        }).catch((response) => {
        window.bus.$emit('openErrorModal', 'error loading currencies: ' + response.ExceptionMessage)
        return Promise.reject(response)
      })
    }
  }
}

const getters = <GetterTree<CurrencyState, any>>{
  currencies: (state) => {
    return state.currencies
  },
  currencyOptions: (state) => {
    return state.currencyOptions
  },
  currencyNames (state:CurrencyState):any {
    return (currencyIDs:number[]) => {
      return map(filter(state.currencies, currency => (currencyIDs.indexOf(currency.Currency_ID) > -1)), 'Currency_Name')
    }
  }
}
export default ({
  namespaced: true,
  state: new CurrencyState(),
  mutations,
  actions,
  getters
})
